import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, Observable, of, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Entity } from '../models/entity.model';
import { Pagination, PaginationRequest } from '../models/pagination.model';
import * as utils from '../../shared/helpers/utils';
import { GazeMapService } from './gaze-map.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private entitiesSubject = new BehaviorSubject<Pagination<Entity> | null>(null);

  constructor(
    private httpClient: HttpClient,
    private gazeMapService: GazeMapService
  ) { }

  gazeMapsAnalytics(pagination: PaginationRequest): any {
    const entities = pagination.entities?.split(',').filter(Boolean) ?? [];
    const packages = pagination['packages']?.split(',').filter(Boolean) ?? [];
    const queryStringParams: Record<string, any> = {};
    const queryStringParamsArray: string[] = [];
    const filters: Record<string, any> = {};

    queryStringParams['internal'] = true;

    if (packages.length) {
      filters['packageId'] = packages.join('+');
    }

    if (pagination?.['startDate'] || pagination?.['endDate']) {
      filters['date'] = {};
      if (pagination?.['startDate']) {
        filters['date'].init = pagination['startDate'];
      }
      if (pagination?.['endDate']) {
        filters['date'].end = pagination['endDate'];
      }
    }

    queryStringParams['filter_params'] = filters;

    Object.entries(queryStringParams).forEach(([key, value]) => {
      if (key === 'filter_params') {
        queryStringParamsArray.push(`${key}=${btoa(JSON.stringify(value))}`);
      } else {
        queryStringParamsArray.push(`${key}=${value}`);
      }
    });
    return this.gazeMapService.count(queryStringParamsArray.join('&'), '').pipe(
      map((result: any) => {
        const response = result?.response ?? {};
        const countByPackage = response?.count_by_package ?? {};
        const packageIds = response?.package_ids ?? [];

        // Map each package to its count breakdown
        return packageIds.map((packageId: string) => {
          const packageData = countByPackage[packageId] ?? {};
          const progressive = Number(packageData.progressive ?? 0);
          const office = Number(packageData.office ?? 0);
          const singleVision = Number(packageData.singleVision ?? 0);
          const total = progressive + office + singleVision;

          return {
            packageId: Number(packageId),
            progressive,
            office,
            singleVision,
            total
          };
        });
      })
    );

  }
  fitsAnalytics(pagination: PaginationRequest): any {
    /*console.log(pagination);
    return this.httpClient.get<Pagination<Entity>>(environment.apiUrl + '/analytics/fit', { params: utils.cleanParams(pagination) });*/


    const entities = pagination.entities?.split(',');
    let mockResponse: any = [];
    entities!.map(id => mockResponse.push({ id: Number(id), finished: this.finished(), pending: this.pending(), total: this.totalFit() }))

    return of(mockResponse).pipe(delay(500));
  }

  finishedCount: number = 0;
  pendingCount: number = 0;

  finished = () => {
    this.finishedCount = 8888 //Math.floor(Math.random() * 1000);
    return this.finishedCount
  }

  pending = () => {
    this.pendingCount = 8888 //Math.floor(Math.random() * 1000);
    return this.pendingCount
  }

  totalFit = () => {
    return this.finishedCount + this.pendingCount
  }
}
